// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-step-editor-sidebar-media-uploading[data-v-3b10df88]{display:flex;flex-direction:column;justify-content:space-around;align-items:center;border:1px dashed #8e97ab;color:#8e97ab;padding:10px 0;font-weight:700}", ""]);
// Exports
module.exports = exports;
